import Vue from 'vue'
import Router from 'vue-router'

const log = () => import('../pages/log');

const index = () => import('../pages/index');

const enterpriseManagementRouter = () => import('../pages/enterpriseManagement/enterpriseManagementRouter');
const enterpriseManagement = () => import('../pages/enterpriseManagement/enterpriseManagement');
const userOperateRecord = () => import('../pages/enterpriseManagement/userOperateRecord')
const olduserOperateRecord = () => import('../pages/enterpriseManagement/olduserOperateRecord')
const businessDetails = () => import('../pages/enterpriseManagement/businessDetails');
const userWithdrawal = () => import('../pages/enterpriseManagement/userWithdrawal');
const editBusinessManagement = () => import('../pages/enterpriseManagement/editBusinessManagement');

const mealsManagementRouter = () => import('../pages/mealsManagement/mealsManagementRouter');
const mealsList = () => import('../pages/mealsManagement/mealsList');
const addEdition = () => import('../pages/mealsManagement/addEdition');
const mealsOrder = () => import('../pages/mealsManagement/mealsOrder');
const addService = () => import('../pages/mealsManagement/addService');
const addServiceOrder = () => import('../pages/mealsManagement/addServiceOrder');
const upServerList = () => import('../pages/mealsManagement/upServerList');
const couponList = () => import('../pages/mealsManagement/couponList');
const couponListDetail = () => import('../pages/mealsManagement/couponDetailList');
const goodsManagement = () => import('../pages/mealsManagement/goodsManagement');
const classificationManagement = () => import('../pages/mealsManagement/classificationManagement');

const upServerDetail = () => import('../pages/mealsManagement/upServerDetail')

const powerRouter = () => import('../pages/powerManagement/powerRouter');
const powerShop = () => import('../pages/powerManagement/powerShop');
const powerPlatform = () => import('../pages/powerManagement/powerPlatform');
const powerManagementRouter = () => import('../pages/powerManagement/powerManagementRouter');
const powerAuth = () => import('../pages/powerManagement/powerAuth');
const powerOutGood = () => import('../pages/powerManagement/powerOutGood');
 

const messageManagementRouter = () => import('../pages/messageManagement/messageManagementRouter');
const notice = () => import('../pages/messageManagement/notice');
const newsClassification = () => import('../pages/messageManagement/newsClassification');
const newList = () => import('../pages/messageManagement/newList');
const addNews = () => import('../pages/messageManagement/addNews');
const newsLabel = () => import('../pages/messageManagement/newsLabel');
const feedBack = () => import('../pages/messageManagement/feedback');
const feedBackDetails = () => import('../pages/messageManagement/feedbackDetail');
const complaint = () => import('../pages/messageManagement/complaint');
const complaintDetail = () => import('../pages/messageManagement/complaintDetail');
const hotWords = () => import('../pages/messageManagement/hotWords');


const administratorsRouter = () => import('../pages/administrators/administratorsRouter');
const administrators = () => import('../pages/administrators/administrators');
const operationLog = () => import('../pages/administrators/operationLog');


const manageConfigurationRouter = () => import('../pages/manageConfiguration/manageConfigurationRouter');
const websiteManageConfiguration = () => import('../pages/manageConfiguration/websiteManageConfiguration');
const orderManageConfiguration = () => import('../pages/manageConfiguration/orderManageConfiguration');
const baseSetting = () => import('../pages/manageConfiguration/baseSetting');
const domainAudit = () => import('../pages/manageConfiguration/domainAudit');
const templateConfigure = () => import('../pages/manageConfiguration/templateConfigure.vue')

const realmNameRouter = () => import('../pages/realm/realmNameRouter');
const realmName = () => import('../pages/realm/realmName');


Vue.use(Router);

export default new Router({
  routes: [
    //登录
    {
      path: '/log',
      name: 'log',
      /* redirect: '/log',*/
      component: log,
      meta: {
        needLog: false,
        title: '登录'
      }
    },
    //首页
    {
      path: '/pages/index',
      component: index,
      meta: {
        needLog: true,
        title: '首页'
      }
    },
    {
      path: '/',
      //路由重定向
      redirect: '/pages/index',
    },
    //用户管理
    {
      path: '/enterpriseManagementRouter',
      component: enterpriseManagementRouter,
      meta: {
        needLog: true,
        title: '用户管理'
      },
      children: [
        {
          path: '/enterpriseManagementRouter/enterpriseManagement',
          name: 'enterpriseManagement',
          component: enterpriseManagement,
          meta: {
            title: '用户管理'
          }
        },
        {
          path: '/enterpriseManagementRouter/userWithdrawal',
          name: 'userWithdrawal',
          component: userWithdrawal,
          meta: {
            title: '提现管理'
          }
        },
        {
          path: '/enterpriseManagementRouter/businessDetails',
          name: 'businessDetails',
          component: businessDetails,
          meta: {
            needLog: true,
            title: '商户详情'
          },

        },
        {
          path: '/enterpriseManagementRouter/userOperateRecord',
          name: 'userOperateRecord',
          component: userOperateRecord,
          meta: {
            title: '页面流转记录'
          }
        },
        {
          path: '/enterpriseManagementRouter/olduserOperateRecord',
          name: 'olduserOperateRecord',
          component: olduserOperateRecord,
          meta: {
            title: '用户操作记录'
          }
        },


        {
          path: '/enterpriseManagementRouter/editBusinessManagement',
          name: 'editBusinessManagement',
          component: editBusinessManagement
        }
      ]
    },
    //认证管理
    {
      path: '/powerManagementRouter',
      component: powerRouter,
      redirect: '/powerManagementRouter/powerShop',
      meta: {
        needLog: true,
        title: '认证管理'
      },
      children: [{
        path: '/powerManagementRouter/powerShop',
        name: 'powerRouter',
        component: powerShop,
        meta: {
          title: '单店铺认证'
        }
      }, {
        path: '/powerManagementRouter/powerPlatform',
        name: 'powerRouter',
        component: powerPlatform,
        meta: {
          title: '平台认证'
        }
      }, {
        path: '/powerManagementRouter/powerAuth',
        component: powerAuth
      },{
        path: '/powerManagementRouter/powerOutGood',
        name: 'powerRouter',
        component: powerOutGood,
        meta: {
          title: '外卖认证'
        }
        
      }]

    },
    //套餐管理
    {
      path: '/mealsManagementRouter',
      component: mealsManagementRouter,
      meta: {
        needLog: true,
        title: '套餐管理'
      },
      children: [{
          path: '',
          redirect: '/mealsManagementRouter/mealsList'
        },
        {
          path: '/mealsManagementRouter/mealsList',
          component: mealsList,
          meta: {
            title: '套餐列表'
          },


        },
        {
          path: '/mealsManagementRouter/addService',
          component: addService,
          meta: {
            title: '增值服务'
          }

        }, {
          path: '/mealsManagementRouter/addServiceOrder',
          component: addServiceOrder,
          meta: {
            title: '增值订单'
          }

        },
        {
          path: '/mealsManagementRouter/mealsList/addEdition',
          component: addEdition,
          meta: {
            title: '编辑版本'
          }
        },
        {
          path: '/mealsManagementRouter/mealsOrder',
          component: mealsOrder,
          meta: {
            title: '套餐订单'
          },


        },
        {
          path: '/mealsManagementRouter/upServerList',
          component: upServerList,
          meta: {
            title: '升级服务列表'
          },



        },
        {
          path: '/mealsManagementRouter/upServerDetail',
          component: upServerDetail,
          meta: {
            title: '升级服务问题详情'
          },



        }

        , {
          path: '/mealsManagementRouter/couponList',
          component: couponList,
          meta: {
            title: '优惠券列表'
          },


        },
        {
          path: '/mealsManagementRouter/couponListDetail',
          component: couponListDetail,
          meta: {
            title: '优惠券详情列表'
          },

        },
        {
          path: '/mealsManagementRouter/goodsManagement',
          component: goodsManagement,
          meta: {
            title: '商品列表'
          },

        },
        {
          path: '/mealsManagementRouter/classificationManagement',
          component: classificationManagement,
          meta: {
            title: '分类列表'
          },

        },

      ]
    },
    //消息管理
    {
      path: '/messageManagementRouter',
      component: messageManagementRouter,
      meta: {
        needLog: true,
        title: '公告列表'
      },
      children: [{
          path: '',
          redirect: '/messageManagementRouter/notice'
        },
        {
          path: '/messageManagementRouter/notice',
          component: notice,
          meta: {
            title: '公告列表'
          }
        },
        {
          path: '/messageManagementRouter/newsClassification',
          component: newsClassification,
          meta: {
            title: '新闻分类'
          }
        },
        {
          path: '/messageManagementRouter/newList',
          component: newList,
          meta: {
            title: '新闻列表'
          }
        },
        {
          path: '/messageManagementRouter/newList/addNews',
          component: addNews
        },
        {
          path: '/messageManagementRouter/newsLabel',
          component: newsLabel,
          meta: {
            title: '新闻标签'
          }
        }, {
          path: '/messageManagementRouter/hotWords',
          component: hotWords,
          meta: {
            title: '热搜词汇'
          }

        },
		{
		  path: '/messageManagementRouter/feedBack',
		  component: feedBack,
		  meta: {
		    title: '意见反馈'
		  }

		},
        {
          path: '/messageManagementRouter/feedBack/feedBackDetail',
          component: feedBackDetails,
          meta: {
            title: '意见反馈详情'
          }

        },
        {
          path: '/messageManagementRouter/complaint',
          component: complaint,
          meta: {
            title: '投诉建议'
          }

        },
        {
          path: '/messageManagementRouter/complaint/complaintDetail',
          component: complaintDetail,
          meta: {
            title: '投诉建议详情'
          }

        },

      ]
    },
    //管理员管理
    {
      path: '/administratorsRouter',
      component: administratorsRouter,
      meta: {
        needLog: true,
        title: '管理员'
      },
      children: [{
          path: '',
          redirect: '/administratorsRouter/administrators'
        },
        {
          path: '/administratorsRouter/administrators',
          component: administrators,
          meta: {
            title: '管理员'
          }
        },
        {
          path: '/administratorsRouter/operationLog',
          component: operationLog,
          meta: {
            title: '操作日志'
          }
        }
      ]
    },
    //配置管理
    {
      path: '/manageConfigurationRouter',
      component: manageConfigurationRouter,
      meta: {
        needLog: true,
        title: '网站配置'
      },
      children: [{
          path: '',
          redirect: '/manageConfigurationRouter/baseSetting'
        },
        {
          path: '/manageConfigurationRouter/baseSetting',
          component: baseSetting,
          meta: {
            title: '基础配置'
          }
        },
        {
          path: '/manageConfigurationRouter/websiteManageConfiguration',
          component: websiteManageConfiguration,
          meta: {
            title: '网站配置'
          }
        },
        {
          path: '/manageConfigurationRouter/orderManageConfiguration',
          component: orderManageConfiguration,
          meta: {
            title: '订单配置'
          }
        },
        {
          path: '/manageConfigurationRouter/damainAudit',
          component: domainAudit,
          meta: {
            title: '域名配置'
          }
        },
        {
          path: '/manageConfigurationRouter/templateConfigure',
          component: templateConfigure,
          meta: {
            title: '模板配置'
          }
        }

      ]
    },
    //域名配置
    {
      path: '/realmNameRouter',
      component: realmNameRouter,
      meta: {
        needLog: true
      },
      children: [{
          path: '',
          redirect: '/realmNameRouter/realmName'
        },
        {
          path: '/realmNameRouter/realmName',
          component: realmName
        }
      ]
    }
  ],
  //去掉路由地址的#,将哈希模式改为history模式
  /* mode: 'history'*/
})



// WEBPACK FOOTER //
// ./src/router/index.js